export default {
  Action: {
    CHANGE_DISEASE_MATRIX_GROUPING: 'Change Grouping of Disease Matrix',
    CHANGE_GROUPING: 'Change Grouping',
    CHANGE_SORTING: 'Change Sorting',
    CLICK_ABOUT: 'Click About',
    CLICK_ACCOUNT_DETAILS: 'Click Account Details',
    CLICK_ADD_FILTERS: 'Click Add Filters',
    CLICK_APPLY_FILTERS: 'Click Apply Filters button',
    CLICK_CHANGE_PASSWORD: 'Click Change Password',
    CLICK_CLEAR_ALL_FILTERS: 'Click Clear All Filters',
    CLICK_CONTACT_SALES: 'Click Contact Sales',
    CLICK_CONTACT_US: 'Click Contact Us',
    CLICK_CURRENT_LOCATION_ICON: 'Click Current Location icon',
    CLICK_CUSTOM_SETTINGS: 'Click Custom Settings',
    CLICK_CUSTOMIZE_DISEASES: 'Click Customize My Diseases button',
    CLICK_EDIT_CUSTOMIZATIONS: 'Click Edit my customizations',
    CLICK_EDIT_CUSTOMIZATIONS_FROM_ROLE_DESCRIPTION:
      'Click Edit customized diseases from within role description',
    CLICK_EVENT_TOOLTIP: 'Click on event within tooltip',
    CLICK_FINISH_ONBOARDING: 'Click Finish on onboarding screen',
    CLICK_FORGOT_PASSWORD: 'Click Forgot Password',
    CLICK_HIDE_CUSTOMIZED_DISEASES: 'Click Hide Customized Diseases button',
    CLICK_LOG_OUT: 'Click Log Out',
    CLICK_MAP: 'Click on Map',
    CLICK_MAP_PIN: 'Click on map pin',
    CLICK_MODIFY_FILTERS: 'Click Modify Filters',
    CLICK_NAVIGATION_BAR_LINK: 'Click link in Navigation bar',
    CLICK_NOTIFICATIONS: 'Click Notifications',
    CLICK_NEXT_ONBOARDING: 'Click Next on onboarding screen',
    CLICK_OUTBREAK_POTENTIAL_COLLAPSE: 'Click to collapse outbreak potential',
    CLICK_OUTBREAK_POTENTIAL_EXPAND: 'Click to expand outbreak potential',
    CLICK_PREVIOUS_ONBOARDING: 'Click Previous on onboarding screen',
    CLICK_PRIVACY_POLICY: 'Click Privacy Policy',
    CLICK_READ_MORE: 'Click Read More',
    CLICK_REFERENCE_LINK: 'Click on Reference link',
    CLICK_RESET_FILTER_AOI: 'Click Reset to Default for AOI',
    CLICK_RESET_TO_ROLE_PRESET: 'Click Reset to presets',
    CLICK_SEE_CUSTOM_EVENTS: 'Click See my custom events',
    CLICK_SEE_ALL_EVENTS: 'Click See all events',
    CLICK_SIGN_IN: 'Click Sign In button',
    CLICK_SIGN_IN_REMEMBER_ME: 'Click on "Remember me" checkbox on Sign In page',
    CLICK_SIGN_UP: 'Click Sign Up button',
    CLICK_TERMS_OF_SERVICE: 'Click Terms of Service',
    CLICK_UPDATE_CUSTOM_SETTINGS: 'Click Update Custom Settings',
    CLICK_ZOOM_IN: 'Click on Zoom In',
    CLICK_ZOOM_OUT: 'Click on Zoom Out',
    CLOSE_COUNTRY_TOOLTIP: 'Close country tooltip',
    CLOSE_EVENT_LIST: 'Close Event List',
    CLOSE_FILTERS_PANEL_X_ICON: 'Close filters panel with X',
    COLLAPSE_ADDITIONAL_EVENTS_EVENT_LIST: 'Collapse additional events with risk to user locations',
    COLLAPSE_EVENT_DETAILS_SECTION: 'Collapse Event Details section',
    COLLAPSE_DISEASE_GROUP_EVENT_LIST: 'Collapse disease card in event list',
    COLLAPSE_DISEASE_MATRIX_GROUP_BY_SECTION: 'Collapse Group by section in Disease Matrix',
    EXPAND_ADDITIONAL_EVENTS_EVENT_LIST: 'Expand additional events with risk to user locations',
    EXPAND_DISEASE_GROUP_EVENT_LIST: 'Expand disease card in event list',
    EXPAND_DISEASE_MATRIX_GROUP_BY_SECTION: 'Expand Group by section in Disease Matrix',
    NAVIGATE_FROM_REGISTRATION_TO_SIGN_IN: 'Navigate to Sign In page from Registration page',
    NAVIGATE_FROM_SIGN_IN_TO_REGISTRATION: 'Navigate to Registration page from Sign In page',
    OPEN_DISEASE_RISK_DETAILS: 'Open Disease Risk Details',
    OPEN_EVENT_DETAILS: 'Open Event Details',
    OPEN_EVENT_LIST: 'Open Event List',
    OPEN_LOCATION_RISK_DETAILS: 'Open Location Risk Details',
    PAN_MAP: 'Pan on Map',
    RETURN_TO_EVENT_LIST_TOOLTIP: 'Go back to event list within tooltip',
    UPDATE_AOI: 'Update Areas of Interest',
    UPDATE_FILTERS_FROM_EVENT_LIST: 'Update Filters from collapsible section of Event List',
    UPDATE_NOTIFICATION_PREFERENCES: 'Update Notification Preferences',
  },

  Category: {
    AUTHENTICATION: 'Authentication',
    CONTACT: 'Contact',
    DISEASES: 'Diseases',
    EMAIL: 'Email',
    EVENT_DETAILS: 'Event Details',
    EVENT_LIST: 'Event List',
    EVENTS: 'Events',
    FILTERS: 'Filters',
    LOCATIONS: 'Locations',
    MAP: 'Map',
    MAP_TOOLTIP: 'Map Tooltip',
    NAVIGATION: 'Navigation',
    PRE_AUTH: 'Pre-Auth',
    SETTINGS: 'Settings',
    ONBOARDING: 'Onboarding',
  },

  UrlTracking: {
    UTM_CAMPAIGN_CONFIRMATION: 'confirmation',
    UTM_CAMPAIGN_EVENT_ALERT: 'alert_new',
    UTM_CAMPAIGN_PROXIMAL: 'local_activity',
    UTM_CAMPAIGN_RESET_PASSWORD: 'reset_password',
    UTM_CAMPAIGN_WEEKLY_BRIEF: 'weekly_brief',
    UTM_CAMPAIGN_WELCOME: 'welcome',
    UTM_MEDIUM_EMAIL: 'email',
    UTM_SOURCE_EMAIL: 'insights_email',
  },
};
